/* eslint-disable no-magic-numbers */
import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import { useIntl } from '@futrli/localisation';

import { useReportBuilderContext } from '../../report-builder.context';

import styles from './sidebar.scss';
import { useI18nConstants } from '../../use-i18n-constants';
import { Checkbox, CheckboxGroup } from 'carbon-react/lib/components/checkbox';

export const SidebarTagsPanel = () => {
  const intl = useIntl();
  const { tags, updateTemplateTags } = useReportBuilderContext();
  const { templateTags } = useI18nConstants();
  const [selectedTags, setSelectedTags] = useState<string[]>(tags);
  const updateTagsTimer = useRef<number>();

  const handleSelectedTagsChange = (value: string) => {
    let updateTemplate = false;
    let newSelectedTags: string[] = [];
    if (selectedTags.includes(value)) {
      newSelectedTags = selectedTags.filter(tag => tag !== value);
      setSelectedTags(newSelectedTags);
      updateTemplate = true;
    } else {
      if (selectedTags.length < 3) {
        updateTemplate = true;
        newSelectedTags = [...selectedTags, value];
        setSelectedTags(newSelectedTags);
      }
    }
    if (updateTemplate) {
      clearTimeout(updateTagsTimer.current);
      updateTagsTimer.current = (setTimeout(() => {
        // patch template
        updateTemplateTags(newSelectedTags);
      }, 500) as unknown) as number;
    }
  };

  return (
    <div className={clsx(styles.sidebarTagsPanel)}>
      <CheckboxGroup
        legend={intl.formatMessage({
          id: 'reporting.select_up_to_3_tags',
          defaultMessage: 'Select up to 3 tags for this template'
        })}
      >
        {templateTags.map(option => {
          const selected = selectedTags.includes(option.value);
          return (
            <Checkbox
              onChange={e => handleSelectedTagsChange(e.target.value)}
              checked={selected}
              disabled={selectedTags.length > 2 && !selected}
              key={option.value}
              label={option.name}
              value={option.value}
            />
          );
        })}
      </CheckboxGroup>
    </div>
  );
};
